<section class="qualification-questionnaire">
  <div class="qualification-state" *ngIf="loading">
    Loading qualification questions...
  </div>

  <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="alert alert-success" *ngIf="message">{{ message }}</div>

  <ng-container *ngIf="!loading">
    <div class="alert alert-info" *ngIf="!flightSchoolExaminerId">
      Save the Unit Member before entering qualification responses.
    </div>

    <div class="alert alert-warning"
      *ngIf="flightSchoolExaminerId && singleChoiceQuestions.length === 0 && tableQuestions.length === 0">
      No active qualification questions are configured. Run the Unit Member qualification seed script.
    </div>

    <article class="choice-panel"
      *ngFor="let question of singleChoiceQuestions; trackBy: trackQuestion">
      <header>
        <h3>{{ question.definition.UnitMemberQualificationType }}</h3>
        <span>Select one if applicable</span>
      </header>

      <div class="choice-options">
        <label class="choice-option"
          *ngFor="let option of question.options; trackBy: trackOption"
          [class.selected]="question.response.UnitMemberQualificationOptionId === option.UnitMemberQualificationOptionId">
          <input type="radio"
            [name]="'qualification-' + question.definition.UnitMemberQualificationTypeId"
            [value]="option.UnitMemberQualificationOptionId"
            [checked]="question.response.UnitMemberQualificationOptionId === option.UnitMemberQualificationOptionId"
            [disabled]="readOnly"
            (change)="setOption(question, option.UnitMemberQualificationOptionId)">
          <span>{{ option.UnitMemberQualificationOption }}</span>
        </label>

        <button class="btn btn-link btn-sm clear-answer"
          type="button"
          *ngIf="!readOnly && question.response.UnitMemberQualificationOptionId"
          (click)="clearAnswer(question)">
          Clear selection
        </button>
      </div>
    </article>

    <article class="qualification-table-panel" *ngIf="tableQuestions.length > 0">
      <header>
        <h3>Select applicable items</h3>
      </header>

      <div class="qualification-table-scroll">
        <table class="qualification-table">
          <thead>
            <tr>
              <th class="item-number">Item No.</th>
              <th>Qualification</th>
              <th class="answer-column">Response</th>
              <th class="applicable-column">Number Applicable</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let question of tableQuestions; trackBy: trackQuestion"
              [class.invalid]="getValidationMessage(question)">
              <td class="item-number">{{ question.itemNumber }}</td>
              <td class="question-text">
                {{ question.definition.UnitMemberQualificationType }}
                <small *ngIf="question.definition.MaximumValue">
                  Maximum {{ question.definition.MaximumValue }}.
                </small>
              </td>
              <td class="answer-column">
                <div class="yes-no-control"
                  *ngIf="question.definition.UnitMemberQualificationResponseTypeId === responseTypes.yesNo">
                  <label [class.selected]="question.response.YesNoValue === true">
                    <input type="radio"
                      [name]="'yes-no-' + question.definition.UnitMemberQualificationTypeId"
                      [checked]="question.response.YesNoValue === true"
                      [disabled]="readOnly"
                      (change)="setYesNo(question, true)">
                    Yes
                  </label>
                  <label [class.selected]="question.response.YesNoValue === false">
                    <input type="radio"
                      [name]="'yes-no-' + question.definition.UnitMemberQualificationTypeId"
                      [checked]="question.response.YesNoValue === false"
                      [disabled]="readOnly"
                      (change)="setYesNo(question, false)">
                    No
                  </label>
                  <button class="btn btn-link btn-sm clear-answer"
                    type="button"
                    *ngIf="!readOnly && question.response.YesNoValue !== null && question.response.YesNoValue !== undefined"
                    (click)="clearAnswer(question)">
                    Clear
                  </button>
                </div>

              </td>
              <td class="applicable-column">
                <div *ngIf="question.definition.UnitMemberQualificationResponseTypeId === responseTypes.number">
                  <input class="form-control numeric-answer"
                    type="number"
                    min="0"
                    step="1"
                    [max]="question.definition.MaximumValue"
                    [ngModel]="question.response.NumericValue"
                    [disabled]="readOnly"
                    (ngModelChange)="setNumeric(question, $event)">
                  <small class="validation-message" *ngIf="getValidationMessage(question)">
                    {{ getValidationMessage(question) }}
                  </small>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </article>
  </ng-container>
</section>
